<template>
  <div>
    <div class="d-flex">
      <app-title-text2 class="patient-card-number-title" text="診察券番号"></app-title-text2>
      <div v-if="!isEditing" id="pills-content1">{{ oldValue }}</div>
      <div v-else id="pills-content2">
        <input
          id="customer_pet_patient_card_number"
          v-model="value"
          type="text"
          name="customer_pet[patient_card_number]"
          class="form-control content-text mb-3"
          placeholder="診察券番号を入力"
        />
        <app-normal-button
          class="active"
          title="キャンセル"
          @click.native="finishEditing()"
        ></app-normal-button>
        <app-primary-button
          class="active patient-card-number-save"
          title="保存"
          @click.native="save()"
        ></app-primary-button>
        <span class="small patient-card-number-save"
          >※ 診察券番号を編集し保存すると、編集内容が飼い主さんへ通知されます</span
        >
      </div>
      <app-link
        v-if="!isEditing"
        class="mf-2 patient-card-number-edit"
        text="編集"
        @click.native="startEditing()"
      ></app-link>
    </div>
  </div>
</template>

<script>
import { not_emoji } from '@v2/vee-validate/custom_rules.js';
import TitleText2 from '../common/text/title-text2.vue';

export default {
  components: {
    appTitleText2: TitleText2,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isEditing: false,
      oldValue: this.text,
      value: this.text,
    };
  },
  methods: {
    startEditing() {
      this.isEditing = true;
    },
    finishEditing() {
      this.isEditing = false;
      this.value = this.oldValue;
    },
    toHalfAlphanumeric(str) {
      return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (x) => String.fromCharCode(x.charCodeAt(0) - 0xfee0));
    },
    save() {
      const patient_card_number = this.toHalfAlphanumeric(this.value);

      if (patient_card_number.length > 30) {
        return this.$swal('診察券番号は30文字以内で設定して下さい。');
      }

      if (!not_emoji.validate(patient_card_number)) {
        return this.$swal('診察券番号には絵文字を設定できません。');
      }

      $.ajax({
        url: this.action,
        type: 'POST',
        data: {
          utf8: '✓',
          _method: 'patch',
          authenticity_token: this.token,
          customer_pet: {
            patient_card_number: patient_card_number,
          },
        },
      })
        .then(() => {
          this.isEditing = false;
          this.value = patient_card_number;
          this.oldValue = patient_card_number;
        })
        .catch(() => {
          this.$swal('登録に失敗しました。');
        });
    },
  },
};
</script>

<style lang="sass" scoped>
#pills-content1
  word-break: break-all
  margin-right: 20px
.content-text
  border: solid 2px #8ce1e6
.patient-card-number-title
  margin-right: 15px
  font-weight: normal
  min-width: 120px
.patient-card-number-edit
  color: #28c3cd !important
  cursor: pointer
  min-width: 50px
  white-space: nowrap
.patient-card-number-save
  margin-left: 10px
</style>
